import type { VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../generic';
import DropdownButton from '../../generic/DropdownButton';

import useSnippetGrouping from './hooks/useSnippetGrouping';

const groupingLabels = {
  // Note: these need to be wrapped in a span instead of a fragment because the
  // container has a flexbox that spreads the items in the dropdown.
  ungrouped: (
    <span>
      <Icon icon={icons.list} /> Ungrouped
    </span>
  ),
  package: (
    <span>
      <Icon icon={icons.listTree} /> Package
    </span>
  ),
};

const groupingOptions = Object.keys(groupingLabels) as Array<keyof typeof groupingLabels>;

/**
 * A dropdown to select the grouping of snippets.
 */
const SnippetGroupingDropdown: VoidFunctionComponent = () => {
  const { snippetGrouping, setSnippetGrouping } = useSnippetGrouping();
  return (
    <DropdownButton
      id="snippet-grouping-dropdown"
      title={groupingLabels[snippetGrouping]}
      onSelect={(grouping) => {
        setSnippetGrouping(grouping);
      }}
      size="medium"
    >
      {groupingOptions.map((labelKey) => (
        <DropdownButton.Item
          key={labelKey}
          eventKey={labelKey}
          active={labelKey === snippetGrouping}
        >
          {groupingLabels[labelKey]}
        </DropdownButton.Item>
      ))}
    </DropdownButton>
  );
};

export default SnippetGroupingDropdown;
